/*
 * $Id:: ConfirmDialog.js 2020/11/11 12:46 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    email: {
        color: theme.palette.text.mainGreen,
    },
    buttonAccept: {
        background: theme.palette.text.mainGreen,
        borderColor: theme.palette.text.mainGreen,
        '&:hover': {
            background: theme.palette.text.mainGreen,
            borderColor: theme.palette.text.mainGreen
        },
    }
}));

const ConfirmDialog = ({ email, open, onAccept }) => {
    const classes = useStyles();
    const emailStyled = <span className={classes.email}>{email}</span>;
    return (
        <Dialog open={open} onClose={onAccept} aria-labelledby="reset-account-accept-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{t('reset.password.status.dialog')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('reset.password', { email: emailStyled })}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onAccept} className={classes.buttonAccept}>
                    {t('accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
